import {
  RESET_MESSAGE_WITH_CODE,
  SET_MESSAGE_WITH_CODE
} from "../actions/action-types";

export const setMessageWithCodeReducer = (state = "", action) => {
  if (action.type === SET_MESSAGE_WITH_CODE) {
    return { text: action.message.text, code: action.message.code };
  } else if (action.type === RESET_MESSAGE_WITH_CODE) {
    return null;
  }

  return state;
};
